import { Link } from 'react-router-dom'
import { ROUTES } from '@web/router'
import { CreateOrganisationForm } from '@web/screens/organisations/create-form'
import { APP_NAME } from '@layerit/brand'

export function NewOrganisationScreen() {
	return (
		<div className="flex flex-col">
			<header className="flex flex-col gap-2">
				<h1 className="font-display text-2xl text-ink">Create a new organisation</h1>
				<p className="text-sm leading-relaxed text-ink-3">
					{APP_NAME} keeps templates, brand kits and connections inside one organisation, so a new one starts empty — with its own
					brand kit, connections and templates rather than a copy of the one you are in.
				</p>
			</header>

			<div className="mt-7">
				<CreateOrganisationForm />
			</div>

			<Link
				className="mt-6 w-fit text-xs font-medium text-ink-3 underline underline-offset-2 hover:text-ink"
				to={ROUTES.chooseOrganisation}
			>
				Back to your organisations
			</Link>
		</div>
	)
}
